import { render } from "./ChainTag.vue?vue&type=template&id=258acc3d&scoped=true&ts=true"
import script from "./ChainTag.vue?vue&type=script&lang=ts"
export * from "./ChainTag.vue?vue&type=script&lang=ts"

import "./ChainTag.vue?vue&type=style&index=0&id=258acc3d&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258acc3d"]])

export default __exports__